// src/hooks/useAttachments.js
import { useCallback, useEffect, useState } from "react";
import { useAttachmentsApi } from "../api/attachmentsApi";

export function useAttachments() {
  const api = useAttachmentsApi();
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAttachments = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAll();
      setAttachments(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api]);

  const addAttachment = async (formData) => {
    try {
      const created = await api.create(formData);
      setAttachments((prev) => [...prev, created]);
      return created;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const updateAttachment = async (id, formData) => {
    try {
      const updated = await api.update(id, formData);
      setAttachments((prev) =>
        prev.map((a) => (a.id === id ? { ...a, ...updated } : a)),
      );
      return updated;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const deleteAttachment = async (id) => {
    try {
      await api.remove(id);
      setAttachments((prev) => prev.filter((a) => a.id !== id));
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  useEffect(() => {
    fetchAttachments();
  }, [fetchAttachments]);

  return {
    attachments,
    loading,
    error,
    fetchAttachments,
    addAttachment,
    updateAttachment,
    deleteAttachment,
  };
}
